// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"ks","modify_order":"ls","modify_order_header":"ms","product_details_form_wrapper":"ns","c_wrapper":"os","save_button":"ps","title":"qs","modify_order_title_wrapper":"rs","note":"ss","buttons_wrapper":"ts"};
    if(module.hot) {
      // 1715091669567
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  